import { configureStore } from "@reduxjs/toolkit";
import authReducer from "./reducers/authSlice";
import subscriptionReducer from "./slices/subscriptionSlice"; // 👈 new import

const store = configureStore({
  reducer: {
    auth: authReducer,
    subscription: subscriptionReducer, // 👈 add this line
  },
});

export default store;
